import React from "react";
import CategoryPage from "./CategoryPage";

const ITEMS = [
  {
    slug: "libri",
    to: "/prodotti/libri",
    label: "Libreria",
    desc: "Volumi cartacei e digitali per esplorare in profondità.",
  },
  {
    slug: "corsi",
    to: "/prodotti/corsi",
    label: "Corsi",
    desc: "Percorsi di apprendimento strutturati e progressivi.",
  },
  {
    slug: "risorse",
    to: "/prodotti/risorse",
    label: "Risorse",
    desc: "Guide, manuali e dossier per approfondire e agire.",
  },
];

export default function ProdottiPage() {
  return (
    <CategoryPage
      eyebrow="Prodotti"
      title="Contenuti che restano."
      description="La Libreria, i corsi e le risorse per costruire conoscenza duratura, un capitolo alla volta."
      items={ITEMS}
      testId="prodotti"
    />
  );
}
